import React__default from 'react';
import classNames from './../external_lib/classnames/index.js';
import Typography from './Typography.js';

function Divider(_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'horizontal' : _b, classes = _a.classes, color = _a.color, dividerStyle = _a.dividerStyle, text = _a.text, size = _a.size, _c = _a.thickness, thickness = _c === void 0 ? 'thin' : _c;
    var styles = {};
    if (color) {
        styles.borderColor = color;
    }
    if (dividerStyle) {
        styles.borderStyle = dividerStyle;
    }
    if (size) {
        if (variant === 'horizontal') {
            styles.width = size;
        }
        if (variant === 'vertical') {
            styles.height = size;
        }
    }
    if (thickness) {
        styles.borderWidth = thickness;
    }
    return (React__default.createElement("div", { style: styles, className: classNames(classes, {
            horizontal: variant === 'horizontal',
            vertical: variant === 'vertical',
            'divider__thin--horizontal': thickness === 'thin' && variant === 'horizontal'
        }) }, text && (React__default.createElement(Typography, { variant: "bodyTextTwo", classes: "divider__content", color: "black" }, text))));
}

export { Divider as default };
//# sourceMappingURL=Divider.js.map
